import React, {useState, useContext, useEffect} from 'react';
import firebase from 'firebase';
import * as dataManager from '../adapters/data';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';
import { forEach } from 'lodash-es';


const SetEmployeeCellModal = (props) => {

    const [context, setContext] = useContext(GlobalContext);
    const [name, setName] = useState('');
    const [qualifications, setQualifications] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [modified, setModified] = useState(false);

    useEffect( () => {
        if (props.show) {
            let array = [];

            context['selectedCells'].map( (e) => {
                if (e !== undefined && e !== null) {
                    let name = context['employeeExcelData'][e.row][e.column].value;
                    console.log(`array - ${JSON.stringify(array)}`);

                    // ensure entry doesn't already exist in array.
                    if (array.find( (f) => {
                        return (f.key === name);
                    }) === undefined && name !== undefined) {
                        array.push({key: name, text: name, value: name});
                    }
                    else {
                        // don't add because it already exists in the array
                    }
                }
    
                // let addedEntry = e;
                // addedEntry['employee'] = e;
    
                // //ensure cell doesn't already exist in array.
                // if ( context['employeeCells'].find( (f) => {
                //     return (f.column === e.column && f.row === e.row);
                // }) === undefined ) {
                //     // add selected cell(s) to employeeCells
                //     setContext( (prevContext) => { //set employeeCells to selectionCells
                //         return {...prevContext, employeeCells: [...prevContext['employeeCells'], addedEntry]}
                //     } );
                // }
                // else {
                //     // don't add because it already exists in the positionCells array
                // }
    
    
                
            });
            
            setEmployeeOptions( array );
            setEmployees( array.map( (e) => { return e.value } ) );
            setModified(false);
        }
            
    }, [props.show]);



    const addEmployee = (selectedCells) => {
        props.onAdd();

        employees.map( (e) => {
            dataManager.addEmployee(e, qualifications.map( q => JSON.parse(q) ));
        });
        setEmployees([]);
        
        props.refreshListCb();

        console.log('Employee Added');

            


        // loop through selection array
        // check if cell is in 'positionCell' array, 
        // check if it is marked as 'position'
        // mark it

        // context['selectedCells'].map( (e) => {
        //     console.log('selected employee - ', e);

        //     let addedEntry = e;
        //     addedEntry['position'] = position;

        //     //ensure cell doesn't already exist in array.
        //     if ( context['positionCells'].find( (f) => {
        //         return (f.column === e.column && f.row === e.row);
        //     }) === undefined ) {
        //         // add selected cell(s) to positionCells
        //         setContext( (prevContext) => { //set positionCells to selectionCells
        //             return {...prevContext, positionCells: [...prevContext['positionCells'], addedEntry]}
        //         } );
        //     }
        //     else {
        //         // don't add because it already exists in the positionCells array
        //     }


            
        // });
        // props.onClose();
    }


    const updateName = (e) => {
        setName(e.target.value);
    }

    const updateQuals = (e, data) => {
        setQualifications(data.value);
    }

    const updateEmployees = (e, data) => {
        setEmployees(data.value);
        setModified(true);
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show}
                    role='dialog'
            >
            <Modal.Header>Add Employees from Selected Cells</Modal.Header>
            <Modal.Content>
                {/* <Input placeholder='Name' onChange={updateName} /> */}

                <Dropdown
                    fluid
                    multiple
                    search
                    selection
                    placeholder='Select the employees you wish to import'
                    options={ employeeOptions ? employeeOptions : [] }
                    // defaultValue= { employeeOptions ? employeeOptions.map( (e) => { return e.value } ) : [] }
                    value={modified === false ? employeeOptions.map( (e) => { return e.value } ) : employees }
                        
                    
                    // options={state['qualifications'] ? state['qualifications'].map( (q) => ({key: q.name, text: q.name, value: q.name} )) : []}
                    onChange={updateEmployees}
                />

                <Dropdown
                    fluid
                    multiple
                    search
                    selection
                    placeholder='Select the qualifications you wish to give'
                    options={context['qualifications'] ? context['qualifications'].map( (q) => ({key: q.name, text: q.name, value: JSON.stringify({id: q.id, name: q.name})} )) : []}
                    onChange={updateQuals}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button basic onClick={props.onClose} >
                Cancel
                </Button>
                <Button color='blue' onClick={ addEmployee } >
                Add
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default SetEmployeeCellModal;